import styled from "styled-components";

export const Container = styled.div`
  .wrapper {
    width: 500px;
    height: 1020px;
    overflow: scroll;
  }

  #container {
    height: 801px;
    overflow: visible;
    padding: 0;
    position: relative;
  }

  .box {
    text-align: center;
    background-color: green;
    font-size: 18px;
    width: 500px;
    height: 300px;
    line-height: 100px;
    color: black;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    z-index: 10;
  }

  .controls {
    background-color: #222;
    border: 1px solid #555;
    color: #bbb;
    font-size: 18px;
    margin: 20px 0;
  }
  .controls ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .controls li {
    display: inline-block;
    padding: 8px 0 8px 10px;
    margin: 0;
  }
  .controls input {
    vertical-align: middle;
    cursor: pointer;
  }
  .controls .controlsTitle {
    border-right: 1px solid #555;
    border-bottom: none;
    padding-right: 10px;
  }
`;
